import { Signal } from '@angular/core';
import { apply, min, schema, SchemaPathTree } from '@angular/forms/signals';
import { ICreateOrderFormModel, IProviderMethod } from '@dss-libs/portal/type/portal-types';
import { createOrderSettingsSchema } from './order-settings.schema';
import { recipientInformationSchema } from './recipient-information.schema';

export function createOrderFormSchema(signingMethods: Signal<readonly IProviderMethod[]>) {
  return schema((path: SchemaPathTree<ICreateOrderFormModel>) => {
    min(path.documents.count, 1, { message: 'VALIDATION_MESSAGES.DOCUMENT_REQUIRED' });
    apply(path.recipientInformation, recipientInformationSchema);
    apply(path.orderSettings, createOrderSettingsSchema(signingMethods));
  });
}
